import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import {
  CcfBox,
  CcfButton,
  CcfTextField,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import { updateselectedCustomer } from './simulator.slice';
import classes from './simulator.module.scss';
import { useDispatch } from 'react-redux';

/**@example */
const EditCustomerAddress = ({
  openEditCustomerAddressDialog,
  setOpenEditCustomerAddressDialog,
  selectedContact,
  editCustomerDetails,
  setEditCustomerDetails,
}: any) => {
  const dispatch = useDispatch();
  /**
   * @example
   */
  const resetEditDialogBox = () => {
    setOpenEditCustomerAddressDialog(false);
  };

  /**@example */
  const handleSaveCustomerDetails = () => {
    dispatch(updateselectedCustomer(editCustomerDetails));
    setOpenEditCustomerAddressDialog(false);
  };
  return (
    <CcfBox>
      <Dialog
        onClose={resetEditDialogBox}
        open={openEditCustomerAddressDialog}
        fullWidth={true}
        maxWidth="md"
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle sx={{ fontWeight: '600' }}>
          {'Edit Customer Address Details'}
        </DialogTitle>
        <DialogContent className={classes.blockContainer}>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              Address Line 1
            </CcfTypography>
            <CcfTextField
              id="confirmPassword"
              variant="outlined"
              size="small"
              value={editCustomerDetails.customerPrimaryAddress?.address1}
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  customerPrimaryAddress: {
                    ...editCustomerDetails.customerPrimaryAddress,
                    address1: event.target.value,
                  },
                  customerSecondaryAddress: {
                    ...editCustomerDetails.customerSecondaryAddress,
                    address1: event.target.value,
                  },
                });
              }}
            />{' '}
          </CcfBox>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              Address Line 2
            </CcfTypography>
            <CcfTextField
              id="address2"
              variant="outlined"
              size="small"
              value={editCustomerDetails.customerPrimaryAddress?.address2}
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  customerPrimaryAddress: {
                    ...editCustomerDetails.customerPrimaryAddress,
                    address2: event.target.value,
                  },
                  customerSecondaryAddress: {
                    ...editCustomerDetails.customerSecondaryAddress,
                    address2: event.target.value,
                  },
                });
              }}
            />{' '}
          </CcfBox>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              City
            </CcfTypography>
            <CcfTextField
              id="confirmPassword"
              variant="outlined"
              size="small"
              value={editCustomerDetails.customerPrimaryAddress?.city}
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  customerPrimaryAddress: {
                    ...editCustomerDetails.customerPrimaryAddress,
                    city: event.target.value,
                  },
                  customerSecondaryAddress: {
                    ...editCustomerDetails.customerSecondaryAddress,
                    city: event.target.value,
                  },
                });
              }}
            />{' '}
          </CcfBox>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              Zip
            </CcfTypography>
            <CcfTextField
              id="confirmPassword"
              variant="outlined"
              size="small"
              value={editCustomerDetails.customerPrimaryAddress?.zip}
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  customerPrimaryAddress: {
                    ...editCustomerDetails.customerPrimaryAddress,
                    zip: event.target.value,
                  },
                  customerSecondaryAddress: {
                    ...editCustomerDetails.customerSecondaryAddress,
                    zip: event.target.value,
                  },
                });
              }}
            />{' '}
          </CcfBox>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              State
            </CcfTypography>
            <CcfTextField
              id="confirmPassword"
              variant="outlined"
              size="small"
              value={editCustomerDetails.customerPrimaryAddress?.state}
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  customerPrimaryAddress: {
                    ...editCustomerDetails.customerPrimaryAddress,
                    state: event.target.value,
                  },
                  customerSecondaryAddress: {
                    ...editCustomerDetails.customerSecondaryAddress,
                    state: event.target.value,
                  },
                });
              }}
            />{' '}
          </CcfBox>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              Country
            </CcfTypography>
            <CcfTextField
              id="confirmPassword"
              variant="outlined"
              size="small"
              value={editCustomerDetails.customerPrimaryAddress?.country}
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  customerPrimaryAddress: {
                    ...editCustomerDetails.customerPrimaryAddress,
                    country: event.target.value,
                  },
                  customerSecondaryAddress: {
                    ...editCustomerDetails.customerSecondaryAddress,
                    country: event.target.value,
                  },
                });
              }}
            />{' '}
          </CcfBox>
        </DialogContent>
        <DialogActions>
          <CcfButton onClick={resetEditDialogBox}>
            <CcfTypography>Cancel</CcfTypography>
          </CcfButton>
          <CcfButton primary onClick={handleSaveCustomerDetails}>
            <CcfTypography>Save</CcfTypography>
          </CcfButton>
        </DialogActions>
      </Dialog>
    </CcfBox>
  );
};

export default EditCustomerAddress;
